// eslint-disable-next-line max-lines-per-function
define( [ 'utility' ], function run( utility ) {
	'use strict';

	var mShowMoreFn = {

		// Default settings
		defaults : {
			limitsMin : '10',
			limits : [ 50, 150, 200 ],
			limitsHardstop : [ 75, 175, 225 ],
			limitsForm : [ 30, 100, 120 ],
			limitsFormHardstop : [ 55, 125, 145 ],
			expand : FRAMEWORK.locale.settings.mShowMore.expand,
			contract : FRAMEWORK.locale.settings.mShowMore.contract,
			about : FRAMEWORK.locale.settings.mShowMore.about,
			description : FRAMEWORK.locale.settings.mShowMore.description,
			inline : false,
			alreadyRun : false,
			fullVisible : true,
			breakpointArray : [ utility.smallTag, utility.mediumTag, utility.largeTag ],
			buttonClassesDefault : [ [ 'a-button--tertiary', 'a-button-icon--up', 'a-button-icon--down' ], [ 'a-button', 'a-button-icon--remove', 'a-button-icon--add' ] ],
		},

		truncateNodeContent : function( node, limit ) {
			var newLimit = limit;
			if ( node.nodeType === Node.TEXT_NODE ) {
				if ( limit < 1 ) {
					node.textContent = '';
				} else {
					node.textContent = node.textContent.substring( 0, newLimit );
					newLimit -= node.textContent.length;
				}
			} else if ( newLimit < 1 ) {
				node.innerHTML = '';
				node.classList.add( 'js-m-show-more-remove-node' );
			} else {
				node.childNodes.forEach( function loop( child ) {
					newLimit = mShowMoreFn.truncateNodeContent( child, newLimit );
				});
			}
			return newLimit;
		},

		truncateNode : function( node, limit ) {
			mShowMoreFn.truncateNodeContent( node, limit );
			node.querySelectorAll( '.js-m-show-more-remove-node' ).forEach( function loop( childNode ) {
				childNode.remove();
			});
		},

		init : function( elm ) {
			var	breakpoint,
				breakpointNew,
				onResizeRefresh;

			if ( !elm.classList.contains( 'js-m-show-more' ) ) {
				elm.classList.add( 'js-m-show-more' );

				elm.mShowMore = {};

				// Pre load the JS for all components within show-more
				elm.querySelectorAll( '.has-module-observer' ).forEach( function loop( element ) {
					utility.trigger( element, 'loadModule' );
				});

				// Get defaults and add / update any specified data-attribute options in html
				elm.mShowMore.settings = utility.extend({}, mShowMoreFn.defaults, utility.getData( elm ) );

				// If used in form, make the form limits the defaults
				if ( elm.parentNode.classList.contains( 'm-form-row__content' ) ) {
					// May need something more specific than just parentNode in case of dodgy usage / AEM parsys divs / etc
					elm.mShowMore.settings.defaultLimits = mShowMoreFn.defaults.limitsForm.slice();
					elm.mShowMore.settings.defaultLimitsHardstop = mShowMoreFn.defaults.limitsFormHardstop.slice();
				} else {
					elm.mShowMore.settings.defaultLimits = mShowMoreFn.defaults.limits.slice();
					elm.mShowMore.settings.defaultLimitsHardstop = mShowMoreFn.defaults.limitsHardstop.slice();
				}

				// If custom data limits have been set, check their validity and reset to default if necessary
				if ( elm.getAttribute( 'data-limits' ) ) {
					mShowMoreFn.getLimits( elm );
				}

				// If has inline variant class, update settings
				if ( elm.classList.contains( 'm-show-more--inline' ) && elm.mShowMore.settings.variant !== 'secondary' ) {
					elm.mShowMore.settings.inline = true;
				}

				if ( elm.mShowMore.settings.variant === 'secondary' ) {
					elm.mShowMore.settings.buttonClasses = elm.mShowMore.settings.buttonClassesDefault[ 1 ];
				} else {
					elm.mShowMore.settings.buttonClasses = elm.mShowMore.settings.buttonClassesDefault[ 0 ];
				}

				// Check for no truncation options and split into array if present
				if ( elm.mShowMore.settings.truncate ) {
					elm.mShowMore.settings.truncate = elm.mShowMore.settings.truncate.split( ',' );
				}

				// Add an ID (if not already present) to link elements together
				if ( !elm.id ) {
					elm.id = utility.makeId( 'm-show-more--' );
					elm.hrefId = '#' + elm.id;
				}

				// Create inner
				utility.wrapInner( elm, 'div', 'm-show-more-inner' );
				elm.mShowMore.inner = elm.querySelector( '.m-show-more-inner' );
				elm.mShowMore.inner.setAttribute( 'aria-live', 'polite' );

				// Create full content holder
				elm.mShowMore.fullHolder = utility.htmlStringToElement( '<div class="u-hidden" aria-hidden="true"></div>' );
				elm.append( elm.mShowMore.fullHolder );

				// Wrap full content
				utility.wrapInner( elm.mShowMore.inner, 'div', 'm-show-more-inner__full' );
				elm.mShowMore.full = elm.mShowMore.inner.querySelector( '.m-show-more-inner__full' );
				elm.mShowMore.full.first = elm.mShowMore.full.firstElementChild;
				elm.mShowMore.full.first.style.marginTop = '0';
				elm.mShowMore.full.lastElementChild.style.marginBottom = '0';
				elm.mShowMore.full.text = elm.mShowMore.full.textContent.replace( /[\s\t\n\r]+/g, ' ' );
				elm.mShowMore.full.setAttribute( 'aria-hidden', 'true' );

				// Create intro
				mShowMoreFn.createIntro( elm );

				// Resize function; also runs on setup to adjust amount of copy visible in the intro
				breakpoint = '';
				onResizeRefresh = utility.debounce( function listener() {
					breakpointNew = utility.getBreakpoint();

					// If the view has changed, adjust the amount of copy shown as per the settings
					if ( breakpointNew !== breakpoint ) {
						elm.mShowMore.settings.breakpointArray.forEach( function loop( size, i ) {
							var truncateFn = function truncateFn() {
									if ( elm.mShowMore.settings.truncate ) {
										if ( elm.mShowMore.settings.truncate[ 0 ] === 'none' ) {
											// Truncate set to none - do not cut at any breakpoint
											elm.mShowMore.settings.cut = false;
										} else if ( elm.mShowMore.settings.truncate[ i ] === 'true' ) {
											// Truncate set to true for this variant
											elm.mShowMore.settings.cut = true;
										} else {
											// Truncate set false for this variant
											elm.mShowMore.settings.cut = false;
										}
									}
								},
								introLength = elm.mShowMore.intro.text.trim().length,
								introTrimmed = elm.mShowMore.intro.text.length - introLength;

							if ( breakpointNew === size ) {
								if ( introLength > elm.mShowMore.settings.limits[ i ] && introLength < elm.mShowMore.settings.limitsHardstop[ i ] ) {
									// Intro text length is greater than the limit, but less than the hardstop
									elm.mShowMore.full.cut = elm.mShowMore.full.text.trim().indexOf( ' ', elm.mShowMore.settings.limitsHardstop[ i ] ) + introTrimmed;
									elm.mShowMore.intro.cut = elm.mShowMore.intro.text.trim().indexOf( ' ', elm.mShowMore.settings.limitsHardstop[ i ] ) + introTrimmed;
									truncateFn();
								} else {
									// Standard
									elm.mShowMore.full.cut = elm.mShowMore.full.text.trim().indexOf( ' ', elm.mShowMore.settings.limits[ i ] ) + introTrimmed;
									elm.mShowMore.intro.cut = elm.mShowMore.intro.text.trim().indexOf( ' ', elm.mShowMore.settings.limits[ i ] ) + introTrimmed;
									truncateFn();
								}
							}
						});
						mShowMoreFn.updateIntro( elm );
						breakpoint = breakpointNew;
					}

					setTimeout( function timeoutFn() {
						if ( elm.mShowMore.settings.fullVisible ) {
							// If full content is visible, match inner height to full so as not to hide it...
							elm.mShowMore.settings.height = Math.ceil( elm.mShowMore.full.offsetHeight ) + 'px';
						} else {
							// ...otherwise match inner height to intro
							elm.mShowMore.settings.height = Math.ceil( elm.mShowMore.intro.offsetHeight ) + 'px';
						}
					}, 10 );
				}, 25 );

				// Create resize and refresh eventListeners and trigger initial resize
				window.addEventListener( 'resize', onResizeRefresh );
				window.addEventListener( 'refresh', onResizeRefresh, false );
				onResizeRefresh();

				// Complete setup
				elm.mShowMore.inner.prepend( elm.mShowMore.intro );
				elm.mShowMore.fullHolder.append( elm.mShowMore.full );
				elm.mShowMore.full.style.display = 'none';
				elm.mShowMore.settings.fullVisible = false;


				elm.mShowMore.open = function open() {
					if ( elm.mShowMore.button && elm.mShowMore.button.classList.contains( elm.mShowMore.settings.buttonClasses[ 2 ] ) ) {
						mShowMoreFn.clickButtonExpand( elm, true );
					}
				};
				elm.mShowMore.close = function close() {
					if ( elm.mShowMore.button && elm.mShowMore.button.classList.contains( elm.mShowMore.settings.buttonClasses[ 2 ] ) ) {
						// Do nothing as collapsed
					} else {
						mShowMoreFn.clickButtonContract( elm, true );
					}
				};

				elm.mShowMore.setSettings = function setSettings( newSettings ) {
					if ( newSettings.expand ) {
						elm.mShowMore.settings.expand = newSettings.expand;
					}
					if ( newSettings.contract ) {
						elm.mShowMore.settings.contract = newSettings.contract;
					}
					if ( newSettings.about ) {
						elm.mShowMore.settings.about = newSettings.about;
					}
					if ( newSettings.description ) {
						elm.mShowMore.settings.description = newSettings.description;
					}
					if ( newSettings.limits ) {
						elm.mShowMore.settings.limits = newSettings.limits;
						mShowMoreFn.getLimits( elm );
					}
					if ( newSettings.truncate ) {
						elm.mShowMore.settings.truncate = newSettings.truncate;
						elm.mShowMore.settings.truncate = elm.mShowMore.settings.truncate.split( ',' );
					}

					// Set the breakpoint to blank to force an update of the show more
					breakpoint = '';
					onResizeRefresh(); // Update the show more
				};
			}

			return elm.mShowMore;
		},

		getLimits : function( elm ) {
			// Custom limits will have been set as string and settings.limits will reflect that, so convert to array
			elm.mShowMore.settings.limits = elm.mShowMore.settings.limits.split( ',' );

			elm.mShowMore.settings.limits.forEach( function loop( rawLimit, i ) {
				var limit = Number.parseInt( rawLimit.trim(), 10 ); // Trim and parse to integer
				if ( Number.isNaN( limit ) ) {
					// Override is either auto or an error - revert to default
					elm.mShowMore.settings.limits[ i ] = elm.mShowMore.settings.defaultLimits[ i ];
				} else if ( limit > elm.mShowMore.settings.defaultLimitsHardstop[ i ] ) {
					// Override exceeds hardstop - pull back to default hardstop
					elm.mShowMore.settings.limits[ i ] = elm.mShowMore.settings.defaultLimitsHardstop[ i ];
				} else if ( limit < elm.mShowMore.settings.limitsMin ) {
					// Override is less than minimum - pull up to default minimum
					elm.mShowMore.settings.limits[ i ] = elm.mShowMore.settings.limitsMin;
				} else {
					// Override accepted - pass through trimmed / parsed value
					elm.mShowMore.settings.limits[ i ] = limit;
				}
			});
		},

		createIntro : function( elm ) {
			var firstChildElement = elm.mShowMore.full.firstElementChild;
			elm.mShowMore.intro = document.createElement( 'div' );
			elm.mShowMore.intro.classList.add( 'm-show-more-inner__intro' );
			elm.mShowMore.intro.setAttribute( 'aria-hidden', 'false' );

			// Check to see if first child element is a paragraph...
			if ( firstChildElement && firstChildElement.tagName === 'P' ) {
				// ...if it is, clone it and use it as the basis for the intro, then grab its text content
				elm.mShowMore.intro.append( firstChildElement.cloneNode( true ) );
				elm.mShowMore.intro.baseHtmlElm = firstChildElement.cloneNode( true );
				elm.mShowMore.intro.text = elm.mShowMore.intro.textContent.replace( /[\s\t\n\r]+/g, ' ' );
			} else if ( firstChildElement.firstElementChild && firstChildElement.firstElementChild.tagName === 'P' ) {
				// ...if it isn't, sniff one layer down in case of wrapper (retain wrapper in case of AEM parsys div, but remove any top margin from firstElementChild to ensure correct spacing)
				firstChildElement.firstElementChild.style.marginTop = '0';
				elm.mShowMore.intro.append( firstChildElement.firstElementChild.cloneNode( true ) );
				elm.mShowMore.intro.baseHtmlElm = firstChildElement.firstElementChild.cloneNode( true );
				elm.mShowMore.intro.text = elm.mShowMore.intro.textContent.replace( /[\s\t\n\r]+/g, ' ' );
			} else {
				// ...otherwise just create an empty text object to it's available to other functions
				elm.mShowMore.intro.text = '';
				elm.mShowMore.intro.baseHtmlElm = '';
			}

			// Set top / bottom margins to retain spacing
			if ( elm.mShowMore.intro.firstElementChild ) {
				elm.mShowMore.intro.firstElementChild.style.marginTop = '0';
				elm.mShowMore.intro.lastElementChild.style.marginBottom = '0';
			}
		},

		// eslint-disable-next-line complexity
		updateIntro : function( elm ) {
			// Count paragraphs
			var parCount = elm.mShowMore.full.querySelectorAll( 'p' ).length;

			// Remove any pre-existing button
			if ( elm.mShowMore.button ) {
				elm.mShowMore.button.remove();
			}

			// Create intro text (or not, as the case may be)
			if ( elm.mShowMore.intro.text === '' && elm.mShowMore.intro.baseHtmlElm === '' ) {
				// First element isn't a paragraph - add button and tighten spacing
				mShowMoreFn.createButton( elm );
				elm.mShowMore.button.classList.add( 'a-button--show-more-tighten' );
			} else if ( elm.mShowMore.full.text.length !== 0 && elm.mShowMore.full.cut === -1 && elm.mShowMore.intro.cut === -1 && parCount < 2 ) {
				// Single short par - show everything
				elm.mShowMore.intro.innerHTML = '';
				if ( elm.mShowMore.intro.baseHtmlElm !== '' ) {
					elm.mShowMore.intro.append( elm.mShowMore.intro.baseHtmlElm.cloneNode( true ) );
				}
			} else if ( ( elm.mShowMore.intro.text !== '' && elm.mShowMore.intro.cut === -1 ) || elm.mShowMore.settings.cut === false ) {
				// Short first par, but more content, or no truncation variant - show first par and add button
				elm.mShowMore.intro.innerHTML = '';
				if ( elm.mShowMore.intro.baseHtmlElm !== '' ) {
					elm.mShowMore.intro.append( elm.mShowMore.intro.baseHtmlElm.cloneNode( true ) );
				}
				mShowMoreFn.createButton( elm );
			} else if ( elm.mShowMore.intro.cut === -1 ) {
				// First element isn't a paragraph - add button and tighten spacing
				mShowMoreFn.createButton( elm );
				elm.mShowMore.button.classList.add( 'a-button--show-more-tighten' );
			} else {
				// First par is abbreviated, add ellipses and read more regardless of further content
				elm.mShowMore.intro.innerHTML = '';
				if ( elm.mShowMore.intro.baseHtmlElm !== '' ) {
					elm.mShowMore.intro.append( elm.mShowMore.intro.baseHtmlElm.cloneNode( true ) ); // Clone original intro paragraph
				}
				mShowMoreFn.truncateNode( elm.mShowMore.intro, elm.mShowMore.intro.cut ); // Truncate intro paragraph
				elm.mShowMore.intro.firstChild.append( utility.htmlStringToElement( '<span class="m-show-more__ellipses">\u2026</span>' ) ); // Append ellipses to end of paragraph
				mShowMoreFn.createButton( elm );
			}

			elm.mShowMore.settings.height = Math.ceil( elm.mShowMore.intro.offsetHeight ) + 'px';
		},

		createButton : function( elm ) {
			elm.mShowMore.button = document.createElement( 'button' );
			utility.setAttributes( elm.mShowMore.button, {
				type : 'button',
				class : 'a-button m-show-more-button a-button-icon ' + elm.mShowMore.settings.buttonClasses[ 0 ],
				'aria-controls' : elm.id,
			});

			if ( elm.mShowMore.settings.inline ) {
				elm.mShowMore.button.classList.add( 'a-button--show-more-inline' );
			}

			elm.mShowMore.buttonText = document.createElement( 'span' );
			elm.mShowMore.buttonText.classList.add( 'a-button__inner' );
			elm.mShowMore.button.append( elm.mShowMore.buttonText );

			elm.mShowMore.button.addEventListener( 'click', function listener( e ) {
				e.preventDefault();
				if ( elm.mShowMore.button && elm.mShowMore.button.classList.contains( elm.mShowMore.settings.buttonClasses[ 2 ] ) ) {
					mShowMoreFn.clickButtonExpand( elm );
				} else {
					mShowMoreFn.clickButtonContract( elm );
				}
			});

			if ( elm.mShowMore.settings.fullVisible ) {
				// Full content visible - retain contract button
				utility.setAttributes( elm.mShowMore.button, {
					class : 'a-button m-show-more-button a-button-icon ' + elm.mShowMore.settings.buttonClasses[ 0 ] + ' ' + elm.mShowMore.settings.buttonClasses[ 1 ],
					'aria-expanded' : 'true',
					'aria-label' : elm.mShowMore.settings.contract + elm.mShowMore.settings.about + elm.mShowMore.settings.description,
				});
				elm.mShowMore.button.classList.add( elm.mShowMore.settings.buttonClasses[ 1 ] );
				elm.mShowMore.buttonText.textContent = elm.mShowMore.settings.contract;
				elm.append( elm.mShowMore.button );
			} else {
				// Intro only - add expand button
				utility.setAttributes( elm.mShowMore.button, {
					'aria-expanded' : 'false',
					'aria-label' : elm.mShowMore.settings.expand + elm.mShowMore.settings.about + elm.mShowMore.settings.description,
				});
				elm.mShowMore.button.classList.add( elm.mShowMore.settings.buttonClasses[ 2 ] );
				elm.mShowMore.buttonText.textContent = elm.mShowMore.settings.expand;

				if ( elm.mShowMore.settings.inline ) {
					elm.mShowMore.intro.firstElementChild.append( elm.mShowMore.button );
				} else {
					elm.append( elm.mShowMore.button );
				}
			}
		},

		clickButtonExpand : function( elm, noFocus ) {
			// Button down - expand
			var ellipsesElm = elm.mShowMore.intro.querySelector( '.m-show-more__ellipses' );

			if ( elm.mShowMore.settings.isAnimating || !elm.mShowMore.button ) {
				// Do nothing as already animating or there is no button
			} else {
				elm.mShowMore.settings.isAnimating = true;

				elm.mShowMore.inner.style.height = Math.ceil( elm.mShowMore.inner.offsetHeight ) + 'px';
				elm.mShowMore.inner.classList.add( 'is-animating' );
				elm.mShowMore.intro.style.opacity = '0';
				elm.mShowMore.intro.setAttribute( 'aria-hidden', 'true' );
				elm.mShowMore.inner.prepend( elm.mShowMore.full );
				elm.mShowMore.full.style.display = 'block';
				elm.mShowMore.full.style.opacity = '1';
				elm.mShowMore.full.setAttribute( 'aria-hidden', 'false' );
				elm.mShowMore.settings.fullVisible = true;
				elm.mShowMore.inner.style.height = Math.ceil( elm.mShowMore.full.offsetHeight ) + 'px';

				// Drop any elipses to avoid clunkiness during animation
				if ( ellipsesElm ) {
					ellipsesElm.classList.add( 'u-hidden' ); // Hide elipses
				}

				// Move inline variant button to avoid clunkiness during animation
				if ( elm.mShowMore.settings.inline ) {
					// If inline variant, append button to correct location...
					elm.append( elm.mShowMore.button );
					if ( noFocus ) {
						// Do not adjust page
					} else {
						// ...then stall long enough for aria-live to take precedence before returning focus
						setTimeout( function timeoutFn() {
							elm.mShowMore.button.focus();
						}, 10 );
					}
				}

				elm.mShowMore.button.classList.remove( elm.mShowMore.settings.buttonClasses[ 2 ] );
				elm.mShowMore.button.classList.add( elm.mShowMore.settings.buttonClasses[ 1 ] );
				elm.mShowMore.buttonText.textContent = elm.mShowMore.settings.contract;
				elm.mShowMore.button.setAttribute( 'aria-expanded', 'true' );
				elm.mShowMore.button.setAttribute( 'aria-label', elm.mShowMore.settings.contract + elm.mShowMore.settings.about + elm.mShowMore.settings.description );

				setTimeout( function timeoutFn() {
					if ( ellipsesElm ) {
						ellipsesElm.classList.remove( 'u-hidden' ); // Display ellipses again if necessary
					}
					elm.mShowMore.intro.remove(); // Remove intro once animation has completed
					elm.mShowMore.inner.style.removeProperty( 'height' );
					elm.mShowMore.settings.isAnimating = false;
					elm.mShowMore.inner.classList.remove( 'is-animating' );
				}, FRAMEWORK.timings.current.t350ms );

				utility.trigger( window, 'refresh' );
			}
		},

		clickButtonContract : function( elm, noFocus ) {
			var scrollParent = utility.scrollParent( elm ),
				buttonTopNow;

			if ( elm.mShowMore.settings.isAnimating || !elm.mShowMore.button ) {
				// Do nothing as already animating or there is no button
			} else {
				elm.mShowMore.settings.isAnimating = true;

				// Button up - contract
				elm.mShowMore.inner.style.height = Math.ceil( elm.mShowMore.inner.offsetHeight ) + 'px';
				elm.mShowMore.inner.classList.add( 'is-animating' );
				elm.mShowMore.full.setAttribute( 'aria-hidden', 'true' );
				elm.mShowMore.inner.prepend( elm.mShowMore.intro );
				elm.mShowMore.intro.setAttribute( 'aria-hidden', 'false' );

				elm.mShowMore.settings.fullVisible = false;
				elm.mShowMore.intro.style.opacity = '1';
				elm.mShowMore.full.style.opacity = '0';
				elm.mShowMore.inner.style.height = Math.ceil( elm.mShowMore.intro.offsetHeight ) + 'px';

				setTimeout( function timeoutFn() {
					elm.mShowMore.fullHolder.append( elm.mShowMore.full );
					elm.mShowMore.full.style.display = 'none';
					elm.mShowMore.inner.style.removeProperty( 'height' );

					if ( noFocus ) {
						// Do not adjust page
					} else {
						buttonTopNow = scrollParent.scrollTop + elm.mShowMore.button.getBoundingClientRect().top;

						if ( scrollParent.scrollTop > buttonTopNow ) {
							scrollParent.scrollTop = buttonTopNow;
						}
					}

					elm.mShowMore.settings.isAnimating = false;
					elm.mShowMore.inner.classList.remove( 'is-animating' );
				}, FRAMEWORK.timings.current.t350ms );

				elm.mShowMore.button.classList.remove( elm.mShowMore.settings.buttonClasses[ 1 ] );
				elm.mShowMore.button.classList.add( elm.mShowMore.settings.buttonClasses[ 2 ] );
				elm.mShowMore.buttonText.textContent = elm.mShowMore.settings.expand;
				elm.mShowMore.button.setAttribute( 'aria-expanded', 'false' );
				elm.mShowMore.button.setAttribute( 'aria-label', elm.mShowMore.settings.expand + elm.mShowMore.settings.about + elm.mShowMore.settings.description );

				if ( elm.mShowMore.settings.inline ) {
					// If inline variant, append button to correct location...
					elm.mShowMore.intro.firstElementChild.append( elm.mShowMore.button );
					if ( noFocus ) {
						// Do not adjust page
					} else {
						// ...then stall long enough for aria-live to take precedence before returning focus
						setTimeout( function timeoutFn() {
							elm.mShowMore.button.focus();
						}, 10 );
					}
				}

				utility.trigger( window, 'refresh' );
			}
		},
	};

	return {
		initInstance : function( el ) {
			return mShowMoreFn.init( el );
		},
	};
});
